<app-bookupp-header></app-bookupp-header>
<section class="skills my-5">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="FAQs-content-child">
                <div class="FAQs-content-child">
                    <div class="etiquette-content-header-container">
                        <h2 class="etiquette-header">Contact Page</h2>
                    </div>
                    <div class="col-sm-6 col-md-4">
                        <div>32 Kloof St</div>
                        <div>Gardens</div>
                        <div>Cape Town</div>
                        <div>8001</div>
                        <div>South Africa</div>
                    </div>
                    <div class="col-12 col-md-4">
                        <h6>Contact Us:</h6>
                        <div>
                            General Enquiries:<br />
                            <a class="text-primary" href="mailto:info@parkupp.co.za">info&#64;parkupp.co.za</a>
                            <br />
                            <br />
                        </div>
                        <div>
                            Mark Bradford<br />
                            <a class="text-primary" href="tel:+27 82 060 5355">+27 82 060 5355</a>
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<app-bookupp-footer></app-bookupp-footer>
